export const CONTACT = '010-4432-9325';
export const CS_EMAIL = 'CS@legalcare.ai';
